function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';
import { classNamesFor } from '../../utils/classNames';
/**
 * The ListItem component collaborates with the List component to provide simple options
 * for displaying lists of information. They are intended to remove the boiler plate of
 * using ul / ol / li and provide more structured options for display
 *
 * - [MDN docs on li](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/li)
 *
 * ## Related Components
 * - [List](../README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <List>
 *   <ListItem>
 *     <Icon type="ps4" />
 *     <span>item 1</span>
 *   </ListItem>
 *   <ListItem>
 *     <Icon type="psvr" />
 *     <span>item 2</span>
 *   </ListItem>
 * </List>
 * ```
 *
 * ## Props
 */

var ListItem = /*#__PURE__*/function (_PureComponent) {
  _inherits(ListItem, _PureComponent);

  var _super = _createSuper(ListItem);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _super.apply(this, arguments);
  }

  _createClass(ListItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          children = _this$props.children,
          iconType = _this$props.iconType,
          className = _this$props.className,
          iconClassName = _this$props.iconClassName;

      var _ListItem$getClassNam = ListItem.getClassName({
        className: className
      }),
          root = _ListItem$getClassNam.root;

      var isTextNode = typeof children === 'string';
      return /*#__PURE__*/React.createElement("li", {
        "data-qa": qa,
        className: root
      }, iconType && /*#__PURE__*/React.createElement(Icon, {
        type: iconType,
        className: iconClassName
      }), isTextNode ? /*#__PURE__*/React.createElement("span", null, children) : children);
    }
  }]);

  return ListItem;
}(PureComponent);

var cx = classNamesFor(ListItem);
/**
 * Gets the classNames attached to the style hooks for this component.
 * @returns {string} the aliased classNames for ListItem
 */

ListItem.getClassName = function (_ref) {
  var className = _ref.className;
  return {
    root: cx(className, {
      'psw-l-space-x-xs': !/psw-l-space-x/.test(className)
    }, {
      'psw-l-line-left-top': !/psw-l-line/.test(className)
    }, 'psw-l-shrink-wrap')
  };
};
/**
 * Defines aliases for classNames used by this component
 */


ListItem.useClassNames = function (classNames) {
  ListItem.classNames = classNames;
};

ListItem.defaultProps = {
  qa: 'list',
  className: '',
  iconType: '',
  children: [],
  iconClassName: ''
};
ListItem.propTypes = {
  /**
   * QA identifier
   */
  qa: PropTypes.string,

  /**
   * Custom class names to use, helpful for applying custom margins and / or padding
   */
  className: PropTypes.string,

  /**
   * Icon to apply to all items in the list
   */
  iconType: PropTypes.string,

  /**
   * The list items to render
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),

  /**
   * The class to apply to the icon if present
   */
  iconClassName: PropTypes.string
};
export default ListItem;